<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Neuro Surgery Department</h2>
      <p>
        The Department of Neuro Surgery provides advanced surgical care for
        disorders involving the brain, spine, and peripheral nerves. Our
        experienced neurosurgeons perform complex procedures including brain
        tumor excisions, spinal fixation, vascular surgeries, and trauma
        management using state-of-the-art technology.
      </p>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <img
          src="@/assets/img/departments/Neurosurgeon.jpg"
          alt="Neuro Surgery Department"
          class="img-thumbnail img-thumbnail-box"
        />
      </div>
      <div class="col-lg-8">
        <p><strong>Department of Neuro Surgery</strong></p>
        <p>
          All operating rooms are equipped with modern microscopes,
          neuronavigation systems, and intraoperative monitoring tools ensuring
          precision and safety. The department maintains a strong focus on
          critical care and post-surgical rehabilitation to help patients
          recover neurological function and regain independence.
        </p>
        <p>
          Our multidisciplinary team includes neurologists, physiotherapists,
          and critical care specialists who provide integrated care from
          diagnosis to recovery. Emergency neurotrauma services and stroke
          management units are available round-the-clock.
        </p>
        <p>
          Patient-centered care, precision, and innovation define our
          neurosurgical practice. The department continues to uphold excellence
          in clinical outcomes through skill, technology, and compassion.
        </p>
      </div>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate2.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Neurosurgery Doctors',
      queryName: 'Neurosurgery',
      teamName: 'Neurosurgery team',
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import '@/scss/sectionTemplate2.scss';
</style>
